import * as React from "react";
interface props {
  className?: string;
}
const ProfileIconSvg = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="189"
    height="189"
    className={className}
    fill="none"
    viewBox="0 0 189 189"
  >
    <rect width="183" height="183" fill="#FEECE6" rx="91.5"></rect>
    <path
      fill="#FF752C"
      d="M131.113 123.836c-5.862-10.135-14.896-17.402-25.439-20.847a27.716 27.716 0 0 0-14.176-51.528 27.714 27.714 0 0 0-14.177 51.528c-10.543 3.441-19.577 10.708-25.439 20.847a3.07 3.07 0 0 0-.36 2.367 3.07 3.07 0 0 0 1.445 1.909 3.07 3.07 0 0 0 2.376.297 3.075 3.075 0 0 0 1.87-1.494c7.252-12.533 20.07-20.016 34.285-20.016s27.032 7.483 34.284 20.016a3.08 3.08 0 0 0 1.871 1.494 3.07 3.07 0 0 0 3.291-1.106 3.07 3.07 0 0 0 .169-3.467m-61.17-44.65a21.555 21.555 0 1 1 21.555 21.555 21.58 21.58 0 0 1-21.556-21.556"
    ></path>
    <rect
      width="47.135"
      height="47.135"
      x="138.519"
      y="138.519"
      fill="#FF752C"
      rx="23.567"
    ></rect>
    <rect
      width="47.135"
      height="47.135"
      x="138.519"
      y="138.519"
      stroke="#fff"
      strokeWidth="4.962"
      rx="23.567"
    ></rect>
    <path
      fill="#fff"
      d="M170.205 162.659a.325.325 0 0 1-.328.328h-6.888v6.888a.325.325 0 0 1-.328.328.327.327 0 0 1-.328-.328v-6.888h-6.888a.327.327 0 0 1-.232-.56.33.33 0 0 1 .232-.096h6.888v-6.888c0-.087.035-.17.096-.232a.33.33 0 0 1 .464 0 .33.33 0 0 1 .096.232v6.888h6.888a.33.33 0 0 1 .328.328"
    ></path>
  </svg>
);

export default ProfileIconSvg;
